import PropTypes from "prop-types"
import { useEffect, useRef } from "react"
import { useHistory } from 'react-router-dom';

const Modal = ({ children, onClose, opened, size = 'lg', title }) => {
  const element = useRef(null)
  const history = useHistory();

  useEffect(() => {
    show()
    return () => {
      $('body > .modal-backdrop').remove() // need when there is a modal on top of another modal
      $('body').removeClass('modal-open')
    }
  }, [])

  useEffect(() => {
    show()
  })

  const onHide = () => {
    if (typeof onClose === 'function') onClose();
    if (appState.objects.returnPath) {
      history.push(appState.objects.returnPath);
      appState.deleteObjectSilent('returnPath');
      return;
    }
    if (typeof onClose === 'string') {
      history.push(onClose);
    }
  };

  const show = () => {
    if (opened) {
      $(element.current).
        modal('show').
        off('hidden.bs.modal', onHide).
        on('hidden.bs.modal', onHide)
    }
  }

  const hide = () => {
    $(element.current).modal('hide')
  }

  if (!opened) return null
  Modal.current = this

  let content = (
    <div className="modal" tabIndex="-1" ref={element}>
      <div className={classNames("modal-dialog modal-dialog-centered", {'modal-xl': size == 'lg', 'modal-sm': size == 'sm'})} style={{ top: '2rem'}}>
        <div className="modal-content">
          { children }
        </div>
      </div>
    </div>
  )
  return ReactDOM.createPortal(content, document.getElementById('modal'))
}

Modal.propTypes = {
  title: PropTypes.string,
  opened: PropTypes.bool,
  children: PropTypes.object,
}

Modal.CloseButton = (props = {}) =>
  <button type="button" className="close close-modal-btn" onClick={() => { Modal.current.hide() }}>
    <span>&times;</span>
  </button>

export default Modal

// document.body.classList.add('modal-open')
// modal-visible show
